import { useRef, useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";

function Recenter({ lat, lng }) {
  const map = useMap();
  useEffect(() => {
    map.setView([lat, lng], map.getZoom(), { animate: true });
  }, [lat, lng, map]);
  return null;
}

function ClickToPlace({ onChange }) {
  useMapEvents({ click: (e) => onChange?.({ lat: e.latlng.lat, lng: e.latlng.lng }) });
  return null;
}

const pinIcon = L.divIcon({
  className: "",
  html: `<div class="encosta-pin"><span>📍</span></div>`,
  iconSize: [36, 36],
  iconAnchor: [18, 36],
});

export default function MiniLocationMap({ lat, lng, onChange, hint = "Arraste pra ajustar", readOnly = false, zoom = 17 }) {
  const markerRef = useRef(null);

  return (
    <div className="relative h-44 rounded-xl overflow-hidden border border-white/10" data-testid="mini-map">
      <MapContainer center={[lat, lng]} zoom={zoom} className="h-full w-full" zoomControl={false} attributionControl={false} scrollWheelZoom={false} doubleClickZoom={false}>
        <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" className="osm-dark-tiles" />
        <Recenter lat={lat} lng={lng} />
        {!readOnly && <ClickToPlace onChange={onChange} />}
        <Marker
          position={[lat, lng]}
          icon={pinIcon}
          draggable={!readOnly}          ref={markerRef}
          eventHandlers={{
            dragend: () => {
              const m = markerRef.current;
              if (!m) return;
              const p = m.getLatLng();
              onChange?.({ lat: p.lat, lng: p.lng });
            },
          }}
        />
      </MapContainer>
      {!readOnly && (
      <div className="absolute bottom-2 left-2 right-2 z-[400] glass rounded-md px-3 py-1.5 text-[10px] text-foreground/80 flex items-center justify-between">
        <span>Arraste o pin ou toque no mapa</span>
        <span className="font-semibold text-primary">{hint}</span>
      </div>
      )}
    </div>
  );
}
